module.exports = __webpack_public_path__ + "img/2_176.3cc03f78.png";